import { PerPersonReaders, Roles, type Role } from "../../auth/roles";
import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";
const ManagementReviewPage = lazyPage(() => import("../people/insights/ManagementReviewPage"), "ManagementReviewPage");
const OneOnOnePrepPage = lazyPage(() => import("../people/insights/OneOnOnePrepPage"), "OneOnOnePrepPage");
const PersonProfilePage = lazyPage(() => import("../people/insights/PersonProfilePage"), "PersonProfilePage");
const TeamMeetingPrepPage = lazyPage(() => import("../people/insights/TeamMeetingPrepPage"), "TeamMeetingPrepPage");

export { ManagementReviewPage, OneOnOnePrepPage, PersonProfilePage, TeamMeetingPrepPage };

/**
 * Who may open `/people/person/:employeeId` in the SPA: OM, Planner and Admin for everyone on the Operations team,
 * plus linked employees (including Shop Supervisors, D-O60) for their own self-view. The API enforces self-only access.
 */
export const PeopleProfileReaders: readonly Role[] = [
  Roles.OperationsManager,
  Roles.Planner,
  Roles.Admin,
  Roles.ShopSupervisor
];

/** People Insights routes (Gate D, D-O80): Person profile + health card, Prepare a 1:1, Team meeting prep, Management review. */
export const peopleInsightsRoutes: AreaRoute[] = [
  { path: "/people/person/:employeeId", allow: PeopleProfileReaders, element: <PersonProfilePage /> },
  { path: "/people/person/:employeeId/one-on-one", allow: PerPersonReaders, element: <OneOnOnePrepPage /> },
  { path: "/people/team-meeting", allow: PerPersonReaders, element: <TeamMeetingPrepPage /> },
  { path: "/people/management-review", allow: PerPersonReaders, element: <ManagementReviewPage /> }
];
